module.exports = __webpack_public_path__ + "img/Capture - 1_3.c2455bb3.png";